<template>
  <v-layout justify-center>
    <v-flex xs12>
      <v-container fluid>
        <v-layout row wrap justify-left>
          <v-flex grow text-xs-center>
            <h4 class="primary--text font-weight-bold text-uppercase pt-1">RIEPILOGO GARE per {{ userData.Denominazione }}</h4>
            <v-icon>bow</v-icon>

            <v-layout fluid row wrap justify-left>
              <v-flex md2 style="width: 130px;" class="px-1 text-xs-right mt-4 pa-0">
                <v-select v-model="filtroAnnoSportivo" :items="anniSportivi" box item-text="Descrizione" label="Anno Sportivo" return-object hide-details></v-select>
              </v-flex>
              <v-flex md8 hidden-sm-and-down>
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </v-flex>
              <v-flex md2 class="px-1 text-xs-right mt-4 pa-0">
                <v-btn @click="aggiorna()" color="primary white--text" class="btnDefault" small> <v-icon small class="mr-1">cached</v-icon>aggiorna </v-btn>
              </v-flex>
            </v-layout>

            <v-layout column>
              <div class="elevation-1 mt-3 bb-3">
                <v-toolbar flat color="white">
                  <v-toolbar-title>Gare valide per la ranking - Indoor</v-toolbar-title>
                </v-toolbar>
                <v-toolbar flat color="white">
                  <h4>Anno Sportivo: {{ filtroAnnoSportivo.Descrizione }}</h4>
                </v-toolbar>
                <v-data-table
                  :headers="headersInDoor"
                  :items="classificaIndoor"
                  :hide-headers="isMobile"
                  :class="{ mobile: isMobile }"
                  disable-initial-sort
                  hide-actions
                  class="subheading"
                >
                  <template slot="items" slot-scope="props">
                    <tr v-if="!isMobile" :style="{ color: getColorCategoria(props.item.categoriaCodice) }">
                      <td class="text-xs-center">{{ props.item.Classe }}</td>
                      <td class="text-xs-center">{{ props.item.categoriaCodice }}</td>
                      <td class="text-xs-right">{{ props.item.PosizioneRanking }}</td>
                      <td class="text-xs-right">{{ props.item.PunteggioRanking }}</td>
                      <td class="text-xs-right">{{ props.item.SpotRanking }}</td>
                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_1 = !props.item.punteggioGara_1 ? '0' : props.item.punteggioGara_1) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_1 = !props.item.spotGara_1 ? '0' : props.item.spotGara_1) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_1 = !props.item.superSpotGara_1 ? '0' : props.item.superSpotGara_1) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_1 = !props.item.perfectGara_1 ? '0' : props.item.perfectGara_1) }}
                            </div>
                          </div>
                        </tr>
                      </td>

                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_2 = !props.item.punteggioGara_2 ? '0' : props.item.punteggioGara_2) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_2 = !props.item.spotGara_2 ? '0' : props.item.spotGara_2) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_2 = !props.item.superSpotGara_2 ? '0' : props.item.superSpotGara_2) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_2 = !props.item.perfectGara_2 ? '0' : props.item.perfectGara_2) }}
                            </div>
                          </div>
                        </tr>
                      </td>

                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_3 = !props.item.punteggioGara_3 ? '0' : props.item.punteggioGara_3) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_3 = !props.item.spotGara_3 ? '0' : props.item.spotGara_3) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_3 = !props.item.superSpotGara_3 ? '0' : props.item.superSpotGara_3) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_3 = !props.item.perfectGara_3 ? '0' : props.item.perfectGara_3) }}
                            </div>
                          </div>
                        </tr>
                      </td>

                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_4 = !props.item.punteggioGara_4 ? '0' : props.item.punteggioGara_4) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_4 = !props.item.spotGara_4 ? '0' : props.item.spotGara_4) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_4 = !props.item.superSpotGara_4 ? '0' : props.item.superSpotGara_4) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_4 = !props.item.perfectGara_4 ? '0' : props.item.perfectGara_4) }}
                            </div>
                          </div>
                        </tr>
                      </td>
                    </tr>
                    <tr v-else :active="props.selected" @click="props.selected = !props.selected">
                      <td class="flex-td">
                        <ul class="flex-content" ma-10>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Classe:  ">{{ props.item.Classe }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Categoria:  ">{{ props.item.categoriaCodice }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Posizione Ranking:  ">{{ props.item.PosizioneRanking }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Punteggio Ranking:  ">{{ props.item.PunteggioRanking }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Spot Ranking:  ">{{ props.item.SpotRanking }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="25 3DRound:  ">
                            {{ (props.item.punteggioGara_1 = !props.item.punteggioGara_1 ? ' 0 ' : props.item.punteggioGara_1) }}
                          </li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="25 Trophy:  ">
                            {{ (props.item.punteggioGara_2 = !props.item.punteggioGara_2 ? ' 0 ' : props.item.punteggioGara_2) }}
                          </li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="40 3DRound:  ">
                            {{ (props.item.punteggioGara_3 = !props.item.punteggioGara_3 ? ' 0 ' : props.item.punteggioGara_3) }}
                          </li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="40 Trophy:  ">
                            {{ (props.item.punteggioGara_4 = !props.item.punteggioGara_4 ? ' 0 ' : props.item.punteggioGara_4) }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <v-spacer></v-spacer>
                  </template>
                  <template slot="no-results">
                    <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
                  </template>
                </v-data-table>
              </div>
            </v-layout>
            <v-layout column>
              <div class="elevation-1 mt-3">
                <v-toolbar flat color="white">
                  <v-toolbar-title>Gare valide per la ranking - Outdoor</v-toolbar-title>
                </v-toolbar>
                <v-toolbar flat color="white">
                  <h4>Anno Sportivo: {{ filtroAnnoSportivo.Descrizione }}</h4>
                </v-toolbar>

                <v-data-table
                  :headers="headersOutDoor"
                  :items="classificaOutdoor"
                  :pagination.sync="pagination"
                  :hide-headers="isMobile"
                  :class="{ mobile: isMobile }"
                  disable-initial-sort
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <tr v-if="!isMobile" :style="{ color: getColorCategoria(props.item.categoriaCodice) }">
                      <td class="text-xs-center">{{ props.item.Classe }}</td>
                      <td class="text-xs-center">{{ props.item.categoriaCodice }}</td>
                      <td class="text-xs-right">{{ props.item.PosizioneRanking }}</td>
                      <td class="text-xs-right">{{ props.item.PunteggioRanking }}</td>
                      <td class="text-xs-right">{{ props.item.SpotRanking }}</td>
                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_1 = !props.item.punteggioGara_1 ? '0' : props.item.punteggioGara_1) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_1 = !props.item.spotGara_1 ? '0' : props.item.spotGara_1) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_1 = !props.item.superSpotGara_1 ? '0' : props.item.superSpotGara_1) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_1 = !props.item.perfectGara_1 ? '0' : props.item.perfectGara_1) }}
                            </div>
                          </div>
                        </tr>
                      </td>

                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_2 = !props.item.punteggioGara_2 ? '0' : props.item.punteggioGara_2) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_2 = !props.item.spotGara_2 ? '0' : props.item.spotGara_2) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_2 = !props.item.superSpotGara_2 ? '0' : props.item.superSpotGara_2) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_2 = !props.item.perfectGara_2 ? '0' : props.item.perfectGara_2) }}
                            </div>
                          </div>
                        </tr>
                      </td>

                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_3 = !props.item.punteggioGara_3 ? '0' : props.item.punteggioGara_3) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_3 = !props.item.spotGara_3 ? '0' : props.item.spotGara_3) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_3 = !props.item.superSpotGara_3 ? '0' : props.item.superSpotGara_3) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_3 = !props.item.perfectGara_3 ? '0' : props.item.perfectGara_3) }}
                            </div>
                          </div>
                        </tr>
                      </td>

                      <td class="text-xs-right">
                        <tr>
                          <div w130px>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.punteggioGara_4 = !props.item.punteggioGara_4 ? '0' : props.item.punteggioGara_4) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">{{ (props.item.spotGara_4 = !props.item.spotGara_4 ? '0' : props.item.spotGara_4) }}</div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.superSpotGara_4 = !props.item.superSpotGara_4 ? '0' : props.item.superSpotGara_4) }}
                            </div>
                            <div style="float: left;" class="text-xs-right w30px pa-0">
                              {{ (props.item.perfectGara_4 = !props.item.perfectGara_4 ? '0' : props.item.perfectGara_4) }}
                            </div>
                          </div>
                        </tr>
                      </td>
                    </tr>
                    <tr v-else :active="props.selected" @click="props.selected = !props.selected">
                      <td class="flex-td">
                        <ul class="flex-content" ma-10>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Classe:  ">{{ props.item.Classe }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Categoria:  ">{{ props.item.categoriaCodice }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Posizione Ranking:  ">{{ props.item.PosizioneRanking }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Punteggio Ranking:  ">{{ props.item.PunteggioRanking }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="Spot Ranking:  ">{{ props.item.SpotRanking }}</li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="25 3DRound:  ">
                            {{ (props.item.punteggioGara_1 = !props.item.punteggioGara_1 ? ' 0 ' : props.item.punteggioGara_1) }}
                          </li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="25 Trophy:  ">
                            {{ (props.item.punteggioGara_2 = !props.item.punteggioGara_2 ? ' 0 ' : props.item.punteggioGara_2) }}
                          </li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="40 3DRound:  ">
                            {{ (props.item.punteggioGara_3 = !props.item.punteggioGara_3 ? ' 0 ' : props.item.punteggioGara_3) }}
                          </li>
                          <li class="text-sm-center font-weight-bold flex-content" data-label="40 Trophy:  ">
                            {{ (props.item.punteggioGara_4 = !props.item.punteggioGara_4 ? ' 0 ' : props.item.punteggioGara_4) }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </template>
                  <template slot="no-results">
                    <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
                  </template>
                  <!-- PAGINAZIONE IN TABELLA  -->
                  <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
                </v-data-table>
              </div>
            </v-layout>
            <v-layout fluid row wrap justify-left>
              <v-flex md3 class="px-1 text-xs-center mt-4">
                <v-text-field v-model="filtraTesto" box label="Cerca tra i sodalizi" clearable hide-details></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout column>
          <div class="elevation-1 mt-3">
            <v-toolbar flat color="white">
              <v-toolbar-title>Classifica personale completa</v-toolbar-title>
            </v-toolbar>
            <v-toolbar flat color="white">
              <h4>Anno Sportivo: {{ filtroAnnoSportivo.Descrizione }}</h4>
            </v-toolbar>
            <v-data-table
              :headers="headers"
              :items="rankingFiltrate"
              :search="filtraTesto"
              :pagination.sync="pagination"
              :hide-headers="isMobile"
              :class="{ mobile: isMobile }"
              hide-actions
              disable-initial-sort
            >
              <template slot="items" slot-scope="props">
                <tr v-if="!isMobile" :style="{ color: getColorCategoria(props.item.categoriaCodice) }">
                  <td class="text-xs-center">{{ props.item.classeCodice }}</td>
                  <td class="text-xs-center">{{ props.item.categoriaCodice }}</td>
                  <td class="text-xs-left">{{ props.item.descrizioneTipoEvento }}</td>
                  <td class="text-xs-center">{{ Util.formattaData(props.item.DataEvento) }}</td>
                  <td class="text-xs-left">{{ props.item.associazioneEventoDenominazione }}</td>
                  <td class="text-xs-right">{{ props.item.PosizioneRanking }}</td>
                  <td class="text-xs-right">{{ props.item.PunteggioRanking }}</td>
                  <td bold class="text-xs-right">{{ props.item.Punteggio }}</td>
                  <td bold class="text-xs-right">{{ props.item.Spot }}</td>
                  <td bold class="text-xs-right">{{ props.item.SuperSpot }}</td>
                  <td bold class="text-xs-right">{{ props.item.Perfect }}</td>
                </tr>
                <tr v-else :active="props.selected" @click="props.selected = !props.selected">
                  <td class="flex-td">
                    <ul class="flex-content" ma-10>
                      <li class="text-sm-center font-weight-bold flex-content" data-label="Classe:  ">{{ props.item.classeCodice }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" data-label="Categoria:  ">{{ props.item.categoriaCodice }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" data-label="Tipo Evento:  ">{{ props.item.descrizioneTipoEvento }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" data-label="Data Evento:  ">{{ Util.formattaData(props.item.DataEvento) }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" data-label="Associazione Evento:  ">{{ props.item.associazioneEventoDenominazione }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" bold data-label="Sodalizio:  ">{{ props.item.associazioneDenominazione }}</li>

                      <li class="text-sm-center font-weight-bold flex-content" bold data-label="Punteggio Ranking:  ">{{ props.item.Punteggio }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" bold data-label="Spot Ranking:  ">{{ props.item.Spot }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" bold data-label="SuperSpot Ranking:  ">{{ props.item.SuperSpot }}</li>
                      <li class="text-sm-center font-weight-bold flex-content" bold data-label="Perfect:  ">{{ props.item.Perfect }}</li>
                    </ul>
                  </td>
                </tr>
              </template>
              <template slot="no-results">
                <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
              </template>
              <template slot="no-data">
                <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
              </template>
              <!-- PAGINAZIONE IN TABELLA  -->
              <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
            </v-data-table>
          </div>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { bus } from '@/main';
  import Util from '@/util';
  import Security from '@/security';
  import FileEntity from './generale/FileEntity';
  import AssociazioneEntity from '@/pages/anagrafica/associazioni/AssociazioneEntity';
  import PartecipazioneEntity from './generale/PartecipazioneEntity';

  export default {
    components: {},
    data() {
      return {
        Util,
        ruoli: Security.ruolo,
        elencoFunzioni: Security.enFunzione,
        formModes: Util.enFormMode,
        filtraTesto: '',
        dialogExport: false,
        dialogClassifica: false,
        selected: [],
        prenotazioneDialog: false,
        isMobile: false,
        filtroAnno: null,
        filtroNumeroTessera: null,
        filtroAnnoSportivo: null,
        headers: [
          { text: 'Classe', sortable: true, value: 'classeCodice', align: 'center', width: '80px' },
          { text: 'Categoria', sortable: true, value: 'categoriaCodice', align: 'center', width: '80px' },
          { text: 'Tipo', sortable: true, value: 'tipoEvento', align: 'center', width: '150px' },
          { text: 'Data Evento', sortable: true, value: 'DataEvento', align: 'center' },
          { text: 'Sodalizio Evento', sortable: true, value: 'associazioneEventoDenominazione', align: 'left' },
          { text: 'Posizione Ranking', sortable: true, value: 'PosizioneRanking', align: 'center', width: '80px' },
          { text: 'Punteggio Ranking', sortable: true, value: 'punteggioRanking', align: 'center', width: '50px' },
          { text: 'Punteggio Gara', sortable: true, value: 'Punteggio', align: 'center', width: '140px' },
          { text: 'Spot', sortable: true, value: 'Spot', align: 'center', width: '140px' },
          { text: 'Super', sortable: true, value: 'Super', align: 'center', width: '140px' },
          { text: 'Perfect', sortable: true, value: 'Perfect', align: 'center', width: '140px' },
        ],
        headersInDoor: [
          { text: 'Classe', sortable: true, value: 'Classe', align: 'center', width: '50px' },
          { text: 'Categoria', sortable: true, value: 'categoriaCodice', align: 'center', width: '50px' },
          { text: 'Posizione Ranking', sortable: true, value: 'posizioneRanking', align: 'center', width: '50px' },
          { text: 'Punteggio Ranking', sortable: true, value: 'punteggioRanking', align: 'center', width: '80px' },
          { text: 'Spot Ranking', sortable: true, value: 'spotRanking', align: 'center', width: '50px' },
          { text: '25 3DRound', sortable: false, value: '', align: 'center', width: '140px' },
          { text: '25 Trophy', sortable: false, value: '', align: 'center', width: '140px' },
          { text: '40 3DRound', sortable: false, value: '', align: 'center', width: '140px' },
          { text: '40 Trophy', sortable: false, value: '', align: 'center', width: '140px' },
        ],
        headersOutDoor: [
          { text: 'Classe', sortable: true, value: 'Classe', align: 'center', width: '50px' },
          { text: 'Categoria', sortable: true, value: 'categoriaCodice', align: 'center', width: '50px' },
          { text: 'Posizione Ranking', sortable: true, value: 'posizioneRanking', align: 'center', width: '50px' },
          { text: 'Punteggio Ranking', sortable: true, value: 'punteggioRanking', align: 'center', width: '80px' },
          { text: 'Spot Ranking', sortable: true, value: 'spotRanking', align: 'center', width: '50px' },
          { text: '40 Round', sortable: false, value: '', align: 'center', width: '140px' },
          { text: '60 Target', sortable: false, value: '', align: 'center', width: '140px' },
          { text: '44 Fusion', sortable: false, value: '', align: 'center', width: '140px' },
          { text: '60 Track', sortable: false, value: '', align: 'center', width: '140px' },
        ],

        pagination: {
          rowsPerPage: -1,
        },
        editedItem: {},
      };
    },
    computed: {
      ...mapGetters('eventiModule', ['getRankingPersonaleView']),
      ...mapGetters('sharedModule', ['getCategorieEvento', 'getCategorieEventoEuropeo', 'getTipiEvento', 'getSezioni', 'getAnniSportivi']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters(['userData']),

      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },

      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },

      ranking() {
        let classificaList = [];
        if (this.getRankingPersonaleView && this.filtroAnnoSportivo != null) {
          classificaList = this.getRankingPersonaleView.filter((i) => {
            return i.annoSportivoId == this.filtroAnnoSportivo.id;
          });
          if (classificaList) {
            classificaList = classificaList[0];
          }
        }
        return classificaList;
      },

      classificaGenerale() {
        let classificaList = [];
        if (this.ranking) {
          classificaList = this.ranking.classificaGenerale;
        }
        return classificaList;
      },
      classificaIndoor() {
        let classificaList = [];
        if (this.ranking) {
          classificaList = this.ranking.rankingIndoor;
        }
        return classificaList;
      },
      classificaOutdoor() {
        let classificaList = [];
        if (this.ranking) {
          classificaList = this.ranking.rankingOutdoor;
        }
        return classificaList;
      },
      categorie() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice != 'FO' && p.Codice != 'DI';
        });
      },
      categorieEuropeo() {
        return this.getCategorieEventoEuropeo;
      },
      anniSportivi() {
        return this.getAnniSportivi;
      },
      tipiEvento() {
        return this.getTipiEvento;
      },
      sezioni() {
        return this.getSezioni;
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      rankingFiltrate() {
        let classificaList = null;
        if (this.classificaGenerale) {
          classificaList = this.classificaGenerale.filter((i) => {
            if (this.categoriaSelected == null) {
              return true;
            } else {
              return i.isAttivo == 1 && i.categoriaCodice == this.categoriaSelected.Codice;
            }
          });
          classificaList = classificaList.filter((i) => {
            if (this.classeSelected == null) {
              return true;
            } else {
              return i.Classe == this.classeSelected;
            }
          });

          return classificaList;
        } else {
          return this.classificaGenerale;
        }
      },
    },
    watch: {
      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
            this.isMobile = false;
            break;
          case 'lg':
            this.isMobile = false;
            break;
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      vm.loadTipologie();
      vm.refreshList();
      vm.filtroAnnoSportivo = {
        id: 183,
        Codice: '20242025',
        Descrizione: '2024/2025',
        Tipo: 'AnnoSportivo',
        Tag: null,
      };

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false;
          break;
      }
    },
    methods: {
      ...mapActions('eventiModule', ['loadRankingPersonaleView', 'exportClassificaGeneraleXLS']),
      ...mapActions('sharedModule', ['loadTipologie']),
      refreshList() {
        const vm = this;
        vm.loadRankingPersonaleView(this.userData.id);
        if (this.filtroAnnoSportivo == null && this.anniSportivi) {
          this.filtroAnnoSportivo = this.anniSportivi[0];
        }
      },

      aggiorna() {
        const vm = this;
        vm.loadRankingPersonaleView(this.userData.id);
        vm.filtroAnnoSportivo = this.anniSportivi[0];
      },
      getColorCategoria(codiceCategoria) {
        if (this.categorie) {
          const cat = this.categorie.filter((a) => {
            return a.Codice == codiceCategoria;
          });
          if (cat.length == 1) {
            return cat[0].Tag.split('|');
          }
        }
      },

      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },

      formatDate(date) {
        if (date) {
          return new Date(date).toLocaleString().split(',')[0];
        }
      },
    },
  };
</script>

<style scoped>
  .mobile table.v-table tr:nth-child(odd) {
    border-left: 2px solid grey;
    border-top: 2px solid grey;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 2px solid green;
    border-top: 2px solid green;
  }
</style>
